/**
 * External dependencies
 */
import { omit } from 'lodash';
import { combineReducers } from 'redux';

/**
 * Internal dependencies
 */
import { START_RESOURCE_INFO_MODAL } from 'state/action-types';

import { createReducer } from 'state/utils';

export const resourceId = createReducer(null, {
    [START_RESOURCE_INFO_MODAL]: (state, { payload }) => payload.resourceId,
});

export default combineReducers({
    resourceId,
});
